<template>
  <div class="no-data">
    <img :src="nullBg" alt />
    <p class="no-data-tip">
      <span>暂无数据</span>
      <a class="highlight" :href="link" v-if="link" :target="link"
        >,{{ msg }}</a
      >
    </p>
  </div>
</template>

<script>
export default {
  name: "no-data",
  props: {
    msg: {
      type: String,
      require: true,
      default: "去看看",
    },
    link: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      nullBg: "https://o.bysjy.com.cn/kzp/template/1565660656-4465.png",
    };
  },
};
</script>

<style lang="scss" scoped>
.no-data {
  text-align: center;

  img {
    width: 92px;
    height: 92px;
  }

  .highlight {
    color: $lightColor;
  }

  span,
  a {
    font-size: 16px;
    line-height: 1.5;
  }

  .no-data-tip {
    color: #999999;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NoData.vue